import { IndicatorLayoutValueFirst } from "./indicator-layout-value-first";
export var IndicatorLayoutDefault = IndicatorLayoutValueFirst;